import { createRouter, createWebHistory } from "vue-router";
import { mainRoutes } from "./mainRoutes";
import { backofficeRoutes } from "./backofficeRoutes";
import { authRoutes } from "./authRoutes";
import { landingRoutes } from "./landingRoutes";

const getRoutes = (all=false) => {
  const routes = []

  if(import.meta.env.VITE_BUILD_MODE == "web" || all){
    routes.push(...landingRoutes)
  }

  routes.push(...authRoutes, ...mainRoutes, ...backofficeRoutes )

  return routes
}

export const routes = getRoutes(true)

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: getRoutes(),
});

export default router;